/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Gtb_User_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Username" |
*
* @param {Module_Settings_Gtb_User_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_gtb_user_placeholder = /** @type {((inputs?: Module_Settings_Gtb_User_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Gtb_User_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Username")
	return /** @type {LocalizedString} */ ("Utilisateur")
});